// extracted by mini-css-extract-plugin
export var arrows = "_3g-6";
export var decrementer = "_3g-a";
export var disabled = "_3g-4";
export var error = "_3g-1";
export var hiddenText = "_3g-b";
export var incrementer = "_3g-9";
export var input = "_3g-8";
export var inputWrapper = "_3g-0";
export var leadingIcon = "_3g-c";
export var readonly = "_3g-3";
export var regular = "_3g-7";
export var small = "_3g-5";
export var warning = "_3g-2";